import { useQuery, UseQueryResult } from 'react-query';
import { AppointmentTypeRetrieve } from 'types';
import { client } from 'utils/api-client';

function useAppointmentType(
  appointmentTypeId: string | undefined,
): UseQueryResult<{ data: AppointmentTypeRetrieve }> {
  return useQuery(
    ['appointmentType', appointmentTypeId],
    () => client.get(`appointment-types/${appointmentTypeId}/`),
    {
      enabled: !!appointmentTypeId,
    },
  );
}

export default useAppointmentType;
